import { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../components/DbServices';
import { AuthContext } from '../context/AuthContext';
import AuthLayout from '../components/AuthLayout';
import { applogo,appname } from '../variables';
import { encryptData } from '../utilities/encryption';
import CryptoJS from "crypto-js";
import Swal from 'sweetalert2';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    if(e) e.preventDefault(); // Handle form submission properly
    setError('');

    if (!email || !password) {
      setError('Please enter your email and password');
      return;
    }

    const encryptedPassword = CryptoJS.SHA256(password).toString();

    try {
      setLoading(true);
      const response = await loginUser({ email, password:encryptedPassword });
      
      if (response?.status === 200) {

        const encryptedUser = encryptData(response.data);
  
  // 2. Store the encrypted string
  localStorage.setItem('user', encryptedUser);
  
  // 3. Keep the context/state as plain object
  login(response.token, response.data);


        // localStorage.setItem('user', JSON.stringify(response.data));
        // login(response.token, response.data); // Fixed to pass correct data object
        navigate('/dashboard');
      } else {
        setError(response?.message || 'Invalid email or password');
      }
    } catch (err) {
      setError('System authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Enter your credentials to access your console"
    >
      {error && (
        <div className="Swal Swal-danger border-0 small fw-bold py-3 rounded-4 mb-4 animate__animated animate__shakeX">
          <i className="fas fa-exclamation-circle me-2"></i> {error}
        </div>
      )}




      <form onSubmit={submit}>
        {/* EMAIL FIELD */}
        <div className="mb-3">
          <label className="form-label small fw-black text-muted mb-2 tracking-wider">EMAIL ADDRESS</label>
          <div className="input-group">
            <span className="input-group-text bg-light border-light-subtle rounded-start-3 px-3">
              <i className="fas fa-envelope text-muted small"></i>
            </span>
            <input
              type="email"
              className="form-control bg-light border-light-subtle py-3 rounded-end-3 shadow-none"
              placeholder="e.g. alex@company.com"
              style={{ fontSize: '14px' }}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
        </div>

        {/* PASSWORD FIELD */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <label className="form-label small fw-black text-muted mb-0 tracking-wider">PASSWORD</label>
            <Link to="/forgot-password" size="sm" className="text-decoration-none small fw-bold text-primary">Forgot?</Link>
          </div>
          <div className="input-group">
            <span className="input-group-text bg-light border-light-subtle rounded-start-3 px-3">
              <i className="fas fa-lock text-muted small"></i>
            </span>
            <input
              type="password"
              className="form-control bg-light border-light-subtle py-3 rounded-end-3 shadow-none"
              placeholder="••••••••"
              style={{ fontSize: '14px' }}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
        </div>

        {/* SIGN IN BUTTON */}
        <button
          className="btn w-100 py-3 rounded-pill fw-black text-white shadow-lg border-0 transition-all hover-lift"
          style={{ 
            background: 'linear-gradient(135deg, #6D28D9 0%, #06B6D4 100%)',
            letterSpacing: '1px'
          }}
          disabled={loading}
          type="submit"
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
          ) : (
            <>SIGN IN TO CONSOLE <i className="fas fa-arrow-right ms-2"></i></>
          )}
        </button>
      </form>

      {/* FOOTER */}
      <div className="text-center mt-5">
        <p className="text-muted small fw-medium">
          New to the platform? <Link to="/register" className="text-primary fw-black text-decoration-none">Create an account</Link>
        </p>
      </div>

      <style>{`
        .hover-lift:hover { transform: translateY(-2px); filter: brightness(1.1); }
        .fw-black { font-weight: 900 !important; }
        .tracking-wider { letter-spacing: 0.05rem; }
      `}</style>
    </AuthLayout>
  );
}